import styled from 'styled-components';

export const Wrapper = styled.div<{ $shouldUseBorderOnFallback: boolean }>`
  ${({ $shouldUseBorderOnFallback }) =>
    $shouldUseBorderOnFallback &&
    `
    [data-testid="logo-placeholder"] {
      border: 1px solid var(--border-soft);
    }
  `}
`;
